// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + ".1743011718122." + {"38":"cc438a8e","453":"69b2aa11"}[chunkId] + ".chunk.js";
};